import browserLang from 'browser-lang';

browserLang({
    languages: ['ua', 'en'],
    fallback: "ua",
});

import "./src/assets/css/nucleo-icons.css";
import "./src/assets/css/nucleo-svg.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "./src/assets/scss/soft-design-system-pro.scss";
